"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Calculation` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Calculation = createSVGIcon(
  <g clipPath="url(#clip0_5445_1462)" stroke="currentColor">
    <path
      d="M19.714.857H4.286a3.43 3.43 0 0 0-3.43 3.429v15.428a3.43 3.43 0 0 0 3.43 3.429h15.428a3.43 3.43 0 0 0 3.429-3.429V4.286A3.43 3.43 0 0 0 19.714.857ZM12 .857v22.286M.857 12h22.286M4.285 6.429h4.286M15.857 6.429h3.428M15.857 15.857h3.428M15.857 19.286h3.428M6.428 4.286V8.57M4.611 15.754l3.634 3.634M8.245 15.754l-3.634 3.634"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>,
  "Calculation",
  {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
